import styled from '@emotion/styled';

export const SWrapper = styled.div`
  .custom-ant-form-item {
    margin-bottom: 12px;
  }
`;
